(()=>{
  if(window.qcLightReady)return;
  window.qcLightReady=true;
  const languageForm=document.getElementById('qc-english-language');
  if(!languageForm&&window.Shopify?.locale==='en'){try{sessionStorage.removeItem('qc-english-attempt')}catch{}}
  if(languageForm){
    let attempted=false;
    try{attempted=sessionStorage.getItem('qc-english-attempt')==='1'}catch{}
    if(!attempted){
      try{sessionStorage.setItem('qc-english-attempt','1')}catch{}
      languageForm.elements.return_to.value=location.pathname+location.search+location.hash;
      languageForm.submit();
    }
  }
  document.addEventListener('click',event=>{
    const choice=event.target.closest('[data-qc-mood]');
    if(choice){
      const section=choice.closest('.qc-moods');
      const cards=[...section.querySelectorAll('[data-qc-feeling]')];
      const match=cards.find(card=>card.dataset.qcFeeling===choice.dataset.qcMood);
      if(match){
        section.querySelectorAll('[data-qc-mood]').forEach(button=>button.setAttribute('aria-pressed',String(button===choice)));
        cards.forEach(card=>card.classList.toggle('is-mood-match',card===match));
        const result=section.querySelector('[data-qc-result]');
        result.textContent=result.dataset.prefix+' '+match.querySelector('h3').textContent;
        match.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'nearest',inline:'center'});
      }
    }
    const motion=event.target.closest('[data-qc-motion]');
    if(motion){
      const paused=motion.getAttribute('aria-pressed')!=='true';
      motion.setAttribute('aria-pressed',String(paused));
      motion.setAttribute('aria-label',paused?motion.dataset.play:motion.dataset.pause);
      motion.querySelector('span').textContent=paused?'▶':'Ⅱ';
      motion.closest('.qc-ribbon').classList.toggle('is-paused',paused);
    }
    const opener=event.target.closest('[data-qc-open]');
    if(opener){
      const dialog=document.getElementById(opener.dataset.qcOpen);
      if(dialog){dialog.showModal();dialog._qcOpener=opener}
    }
    const close=event.target.closest('[data-qc-close]');
    if(close){
      const dialog=close.closest('dialog');
      dialog?.close();
      dialog?._qcOpener?.focus();
    }
    if(event.target instanceof HTMLDialogElement){
      const r=event.target.getBoundingClientRect();
      if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();
    }
  });
  document.addEventListener('cart:update',()=>{
    fetch((window.Shopify?.routes?.root||'/')+'cart.js').then(r=>r.json()).then(cart=>{
      document.querySelectorAll('[data-qc-cart-count]').forEach(el=>el.textContent=cart.item_count);
    }).catch(()=>{});
  });
})();
